import { render } from "./BaseSelect.vue?vue&type=template&id=48c959e9"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__